import {
  HEADER_AUTHORIZATION_KEY,
  getBrickRPCClientInstance,
  injectBrickRPCResponseInterceptor,
  registerAPIServiceClient,
  NotLoginError,
  BrickNotLoginErrCode,
  IClientOptions,
  BrickRsp,
  OldBrickRsp,
} from '@quan/services';
import { InterceptorRequest, Response } from '@quan/http';

import { persistUserStore } from '@/stores';
import { DEVIS_ID_KEY } from './const';

/**
 * 初始化httpClient
 * TODO 这里store看看能不能通用
 * @param handlers
 */
function setupXHR(handlers?: {
  handleLogout?: () => void;
  handleErrorMsg?: (err: Error | BrickRsp | OldBrickRsp) => void;
}) {
  const httpInterceptor = getBrickRPCClientInstance();

  /**
   * 登录前新增登录态以及登录状态检查
   */
  httpInterceptor.interceptor.request.use(async function (req) {
    const { auth = '1' } = req.extra as IClientOptions;
    const userStore = await persistUserStore;
    req.headers.set('x-pin-app-version', '2.0');
    req.headers.set('x-device-sid', localStorage.getItem(DEVIS_ID_KEY) || 'null');
    if (auth === '1' || /GetMemberIntegral4Wechat/.test(req.url)) {
      try {
        const { sid } = await userStore.handleLoginResp();
        req.headers.set(HEADER_AUTHORIZATION_KEY, sid);
      } catch (error) {
        this.lock();
        handlers?.handleLogout?.();
        this.clear();
        console.error('not login req', req);
        return Promise.reject(NotLoginError);
      }
    }
    return req;
  });

  /**
   * brick 通用 handler
   * 处理通用错误处理，以及上报
   */
  injectBrickRPCResponseInterceptor(httpInterceptor);

  /**
   * 业务错误处理
   * 处理登录态失效，错误提示等
   */
  httpInterceptor.interceptor.response.use(
    (res) => res,
    async function (err) {
      // 正常http请求报错
      if (err instanceof Response && err.json()) {
        const data = err.json();
        const code = data.errcode || data.code || 0;
        const errorText = data.errmsg || data.error || '系统错误';
        const { auth = '1', showToast = true } = (err.request as InterceptorRequest).extra;
        if (code === BrickNotLoginErrCode) {
          const userStore = await persistUserStore;
          if (auth === '1') {
            this.lock();
            handlers?.handleLogout?.();
            userStore.LoginOutWithNotXHR().catch((e) => e);
            this.clear();
          }
        }
        if (showToast) {
          // TODO error msg
          console.log(errorText);
        }
        return Promise.reject(data);
      }
      // 其他逻辑处理报错
      const msg = (err as Error)?.message || err;
      if (msg) {
        // TODO error msg
        console.log(msg);
      }
      console.log('xhr unCaptured error', err);
      return Promise.reject(err);
    },
  );

  registerAPIServiceClient(httpInterceptor, env.baseApi);

  return httpInterceptor;
}

export default setupXHR;
